import React, { useEffect, useState } from "react";
import Context from "../../../../Context";
import constant from "../../../../constants";
import { ScrollArea } from "../../../../components/ui";
import { formatThaiDate, getStatusBgClass } from "../utils";

export const CouponHistory = ({ user }) => {
  const { callApi } = Context();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    if (user?.userId) {
      getUserOrders();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.userId]);

  const getUserOrders = async () => {
    const result = await callApi(
      "coupons-getCouponOrder",
      { userId: user.userId },
      { notShowLoading: true }
    );
    setOrders(result?.data || []);
  };

  return (
    <div className="relative bg-white w-full rounded-md shadow-xs border border-slate-200 overflow-hidden">
      <div className="flex items-center justify-between p-3.5 border-b border-slate-200 bg-slate-50/60">
        <h3 className="font-bold text-base text-slate-800">
          คำสั่งซื้อคูปองของลูกค้า
        </h3>
      </div>

      <ScrollArea className="h-[320px] p-3">
        {orders === null ? (
          <div className="w-full min-h-60 flex justify-center items-center">
            <div className="w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : orders.length === 0 ? (
          <div className="h-60 w-full flex justify-center items-center text-slate-400 font-semibold text-sm">
            <p>ไม่พบคูปองของลูกค้ารายนี้</p>
          </div>
        ) : (
          <div className="flex flex-col gap-2">
            {orders.map((o) => (
              <div
                key={o.id || o.shortId}
                onClick={() => window.open(`/coupon/${o.id}`, "_blank")}
                className={`${getStatusBgClass(
                  o.status
                )} grid grid-cols-9 gap-1.5 border border-slate-300/30 p-2.5 rounded-md cursor-pointer hover:opacity-95 hover:shadow-sm transition-all text-xs font-semibold items-center`}
              >
                <div className="col-span-2 truncate">
                  <p className="opacity-80 text-[11px]">รหัสสั่งซื้อ</p>
                  <p className="font-bold text-sm truncate">{o.shortId || o.id?.slice(-5)}</p>
                </div>
                <div className="col-span-2">
                  <p className="opacity-80 text-[11px]">สถานะคำสั่งซื้อ</p>
                  <p className="font-bold text-xs truncate">
                    {constant.statusesTranslate[o.status] || o.status}
                  </p>
                </div>
                <div className="col-span-3">
                  <p className="opacity-80 text-[11px]">ชื่อคูปอง</p>
                  <p className="font-bold text-xs truncate">{o.coupon?.name || "-"}</p>
                </div>
                <div className="col-span-2 text-right">
                  <p className="opacity-80 text-[11px]">หมดอายุ</p>
                  <p className="font-bold text-[11px] truncate">
                    {formatThaiDate(o.coupon?.expireAt)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </ScrollArea>
    </div>
  );
};
